// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module__button___2AESl","secondary":"Button-module__secondary___2Rflm","star":"Button-module__star___3HwVr","destructive":"Button-module__destructive___2t_Ea"};